// extracted by mini-css-extract-plugin
export default {"chunksListContainer":"DraggableChunks_chunksListContainer__yPe42"};